@if (currentUserIsSpecial()) {
  <app-balance-special-users />
} @else {
  <app-balance-members />
}
